import React from "react";
import Button from "../../common/Button/Button";

const CallToAction = () => {
  return (
    <div className="cta-section" data-aos="fade-up">
      <h2 data-aos="zoom-in" data-aos-delay="100">
        Join Us in Making a Difference
      </h2>
      <p data-aos="zoom-in" data-aos-delay="200">
        Every contribution helps build a brighter future for Afghan youth. 
        Together, we can transform lives through the power of education.
      </p>
      <Button
        className="btns"
        buttonStyle="btn--primary"
        buttonSize="btn--large"
        src="donate"
        data-aos="zoom-in"
        data-aos-delay="300"
      >
        Make a Donation Today
      </Button>
    </div>
  );
};

export default CallToAction;